import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, X, Search, Bell } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import NotificationBadge from './NotificationBadge';

const MobileHeader = ({ user, onLogout, realtimeUpdates }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const menuItems = [
    { label: 'Dashboard', path: '/dashboard' },
    { label: 'Documentos', path: '/documents' },
    { label: 'Startup Hub', path: '/startup-hub' },
    { label: 'Simulador de Crisis', path: '/crisis-simulator' },
    { label: 'Diagnóstico PR', path: '/ai-tools?tab=diagnostico' },
    { label: 'Análisis FODA', path: '/ai-tools?tab=foda' },
    { label: 'Estrategia PR', path: '/ai-tools?tab=estrategia' },
    { label: 'Escucha Social', path: '/social' },
    { label: 'Alertas', path: '/alerts' },
    { label: 'Stakeholders', path: '/stakeholders' },
    { label: 'IA Tools', path: '/ai-tools' },
  ];

  const handleNavigation = (path) => {
    navigate(path);
    setMenuOpen(false);
  };

  return (
    <div className="mobile-header">
      <button
        onClick={() => navigate('/dashboard')}
        className="text-xl font-bold text-gradient"
      >
        PRÓXIMA
      </button>

      <div className="flex items-center gap-2">
        <Button
          variant="ghost"
          size="sm"
          className="text-gray-400 relative"
          onClick={() => navigate('/alerts')}
        >
          <Bell className="w-5 h-5" />
          {realtimeUpdates && (
            <NotificationBadge 
              count={realtimeUpdates.unreadCount} 
              className="notification-badge-absolute"
            />
          )}
        </Button>

        <Sheet open={menuOpen} onOpenChange={setMenuOpen}>
          <SheetTrigger asChild>
            <Button variant="ghost" size="sm" className="text-gray-400">
              <Menu className="w-6 h-6" />
            </Button>
          </SheetTrigger>
          <SheetContent side="right" className="glass-strong w-[280px]">
            <div className="flex flex-col h-full">
              {/* User Info */}
              <button onClick={() => handleNavigation('/profile')} className="flex items-center gap-3 mb-6 pb-6 border-b border-white/10 w-full text-left hover:bg-white/5 rounded-lg p-2 -m-2 transition-colors" data-testid="mobile-profile-link">
                {user.picture ? (
                  <img src={user.picture} alt={user.name} className="w-12 h-12 rounded-full border-2 border-purple-500" />
                ) : (
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-purple-500/40 to-pink-500/40 border-2 border-purple-500 flex items-center justify-center">
                    <span className="text-lg font-bold text-purple-300">{user.name?.[0] || "?"}</span>
                  </div>
                )}
                <div className="flex-1 min-w-0">
                  <p className="text-white font-semibold truncate">{user.name}</p>
                  <p className="text-xs text-gray-400 truncate">{user.email}</p>
                  <p className="text-[10px] text-purple-400 mt-0.5">Ver perfil</p>
                </div>
              </button>

              {/* Menu Items */}
              <nav className="flex-1 space-y-1">
                {menuItems.map((item) => (
                  <button
                    key={item.path}
                    onClick={() => handleNavigation(item.path)}
                    className="w-full text-left px-4 py-3 text-gray-300 hover:text-white hover:bg-white/10 rounded-lg transition-colors"
                  >
                    {item.label}
                  </button>
                ))}
              </nav>

              {/* Logout */}
              <Button
                variant="outline"
                className="w-full border-red-500/30 text-red-400 hover:bg-red-500/10"
                onClick={() => {
                  onLogout();
                  setMenuOpen(false);
                }}
              >
                Cerrar Sesión
              </Button>
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </div>
  );
};

export default MobileHeader;
